import {lazy} from "react";

export const ReportVoyagePointAveragesLazy = lazy(()=>import('./ReportVoyagePointAverages'))